// extracted by mini-css-extract-plugin
export default {"container":"DispatcherOrder_container__OUsX9","heading":"DispatcherOrder_heading__d1PCY"};